// Archivo: /src/componentsIni/Footer.js

"use client"

import { useState, useEffect } from "react";
import { Facebook, Instagram, UserPlus, Music2 } from "lucide-react";


import { Link } from "react-router-dom";
import logo from "../assets/logo.png";
import './Footer.css';

// Importamos las imágenes de los botones
import appStoreBadge from '../assets/descargarApple.png';
import googlePlayBadge from '../assets/descargarPlayStore.png';

export default function Footer() {
  const [titleLoaded, setTitleLoaded] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setTitleLoaded(true);
    }, 300);
  }, []);

  const appStoreUrl = "https://apps.apple.com/ec/app/parkingclub/id6747083941";
  const playStoreUrl = "https://play.google.com/store/apps/details?id=com.parkinguser.parkingusers&hl=es_EC";

  return (
    <footer className="footer-ini">
      <div className="container-ini">
        <div className="footer-content-ini">
          
          {/* Columna 1: Información de la Empresa */}
          <div className="footer-info-ini">
            <div className={`logo-ini footer-logo-ini ${titleLoaded ? "title-loaded-ini" : ""}`}>
              <img
                src={logo || "/placeholder.svg"}
                alt="Parking Club Logo"
                className="logo-image-ini"
                style={{ height: "40px", width: "40px" }}
              />
              <div className="logo-text-wrapper-ini notranslate" translate="no">
                <div className="title-animation-container-ini">
                  <span className="logo-parking-ini" style={{ color: "white" }}>
                    Parking
                  </span>
                  <span className="logo-club-ini" style={{ color: "white" }}>
                    Club
                  </span>
                </div>
              </div>
            </div>
            <p className="footer-description-ini">
              Sistema integral para la gestión de parqueaderos que optimiza operaciones y maximiza ingresos.
            </p>
            <div className="footer-social-ini">
              <a href="https://www.facebook.com/profile.php?id=61577803272877&sk=about" className="footer-social-link-ini" aria-label="Facebook"><Facebook size={18} /></a>
              <a href="https://www.instagram.com/parkingclubec" className="footer-social-link-ini" aria-label="Instagram"><Instagram size={18} /></a>
              <a href="https://www.tiktok.com/@parking_clubec" className="footer-social-link-ini" aria-label="TikTok">
    <Music2 size={18} /> {/* Cambia Music por tu icono TikTok si usas el SVG */}
  </a>
            </div>
          </div>

          {/* Columna 2 (antes 3): Descarga la App y CTA */}
          <div className="footer-app-download-ini">
            <h4 className="footer-heading-ini">¡Descarga nuestra App!</h4>
            <div className="footer-store-buttons-ini">
              <a href={appStoreUrl} target="_blank" rel="noopener noreferrer">
                <img 
                  src={appStoreBadge} 
                  alt="Descargar en el App Store" 
                  className="store-badge-ini"
                />
              </a>
              <a href={playStoreUrl} target="_blank" rel="noopener noreferrer">
                <img 
                  src={googlePlayBadge} 
                  alt="Disponible en Google Play" 
                  className="store-badge-ini"
                />
              </a>
            </div>
            <div className="footer-cta-ini">
              <Link to="/encuesta" className="cta-link-ini">
                <button className="cta-button-ini">
                  <UserPlus size={18} />
                  Ser parte de nosotros
                </button>
              </Link>
            </div>
          </div>

        </div>
        <div className="footer-bottom-ini notranslate" translate="no">
          <p className="copyright-ini ">© {new Date().getFullYear()} Parking Club. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
}